<template>
  <app-placeholder-horizontal :imageId="form.imageId" @upload="onUpload"/>
</template>

<script>
import uploadcare from 'uploadcare-widget'
import AppPlaceholderHorizontal from '@/components/App/AppPlaceholderHorizontal'

export default {
  components: {
    AppPlaceholderHorizontal,
  },
  props: {
    step: Object,
  },
  data() {
    return {
      loading: false,
      form: {
        imageId: this.step.image_id,
      }
    }
  },
  methods: {
    async onUpload(imageId) {
      this.loading = true
      try {
        var { data } = await this.$http.put(`/ingredient-steps/${ this.step.id }/image`, {
          image_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.$message.success(data.message)
    },
  },
}
</script>
